<div class="drawer-list-option-container">
    <div class="option-container-left">
        <div class="option-container-left-title" [ngClass]="{'dark': darkMode}">{{ video.title }}</div>
        <div class="option-container-left-middle">{{ video.platform }} {{ video.version }}</div>
        <div class="option-container-left-bottom">{{ video.instructor.firstName }} {{ video.instructor.lastName }}</div>
    </div>
    <img [src]="downloadUrl | async" alt="" class="option-container-img">
</div>